
import {updatedateselection,updatedateselection_sdate_edate, updateDynamicObject, updateKeyValue} from '../store/mainpage_data';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {updatetabpath, updatedashboarddata, updatetagcollectionvalue } from "../store/mainpage_data";
import { isavailableintagcollection } from './Dashboard';

let tagcollectionreplica = {};
let tagcollection = {};
let dashboardjsonwidgetsvalue;
let dashboardnamevalue;
let sdate_edate_selectedvalue;
let tagnames = [];
let tag_collection_query_db = [];
let flag = "year";

// Helper: safe number check
const isNumber = v => typeof v === "number" && !isNaN(v);

// Helper: clone array of points
function clonePoints(arr){
  return arr.map(p => ({...p}));
}

export function datacollect(generalconfig,dashboardjsonwidgetsparams, dashboardnameparams, sdate_edate_selected){
    tag_collection_query_db=[]
    // console.log("tagcollectionreplica key IN DATACOLLECT I AM IN",sdate_edate_selected)
    // console.log("tag_collection_query_db in dataccollect",tag_collection_query_db)
    var dashboardjsonwidgets = dashboardjsonwidgetsparams;
    var sdateedateselected = sdate_edate_selected;
    var tag_collection_configuration = [];

    
    var sdateobject = new Date(sdateedateselected.startdates);
    var edateobject = new Date(sdateedateselected.enddates);
    const difference_msec = edateobject - sdateobject;
    const difference_days = Math.trunc(Number(difference_msec / (1000 * 60 * 60 * 24)+1));
    if (difference_days === 365 || difference_days === 366) {
        flag = "year";
    }else if (difference_days >= 30 && difference_days <= 31) {
        flag = "month";
    }else if (difference_days === 7) {
        flag = "week";
    }else if(difference_days <=3) {
        flag = "day";
    }else{
        flag = "custom";
    }
    //console.log("tagcollectionreplica key dashboardjsonwidgetsparams in DataCollection-difference_msec",difference_msec,"difference_days",difference_days,"flag",flag)
   
    var addLinkageKey= false;
   // console.log("dashboardjsonwidgets ",dashboardjsonwidgets)
    (dashboardjsonwidgets != undefined && dashboardjsonwidgets!=null && Array.isArray(dashboardjsonwidgets)) 
    ?
    dashboardjsonwidgets.map((widgetlist)=>{
            var linkages = "";
            var linkageobject = {}
            var linkagekey = "linkageObject";
            if(widgetlist.props.extended.linkages !== undefined && widgetlist.props.extended.linkages !== null ){
                linkages = widgetlist.props.extended.linkages;
                linkageobject[linkagekey] = linkages;
            }
            {/*console.log("tagcollectionreplica key widgetlist.props.extended.tagprops in DataCollection",widgetlist)*/}
           if (
            widgetlist &&
            widgetlist.props &&
            widgetlist.props.extended &&
            Array.isArray(widgetlist.props.extended.tagprops) &&
            widgetlist.props.extended.tagprops.length > 0
            ) { 
                widgetlist.props.extended.tagprops.map((tagsprops)=>{

                    //console.log("tagcollectionreplica key tagsprops in DataCollection",tagsprops,"tagsprops.config != undefined",tagsprops.config != undefined,"tagsprops.config.configured_value != null",tagsprops.config.configured_value != null,"tagsprops.config.configured_value !== undefined",tagsprops.config.configured_value !== undefined,"tagsprops.config.configured_value!==",tagsprops.config.configured_value!=="","tagsprops.config.configured_value!==calculation_subvalues",tagsprops.config.configured_value!=="calculation_subvalues")
                    if(tagsprops.config != undefined && 
                        tagsprops.config.configured_value != null && 
                        tagsprops.config.configured_value !== undefined && 
                        tagsprops.config.configured_value!=="" && 
                        tagsprops.config.configured_value!=="calculation_subvalues" && 
                        (typeof tagsprops.config.configured_value === "number" || typeof tagsprops.config.configured_value === "string") && 
                        tagsprops.calculation.type_of_operation === "" && 
                        ((tagsprops.config.type_of_config == 'datewise') || (tagsprops.config.type_of_config == 'uniform') || (tagsprops.config.type_of_config == 'constant') || (tagsprops.config.type_of_config == '')))
                        {  
                    // console.log("tagcollectionreplica key tagsprops.config",tagsprops.config,"tagsprops.config.configured_value",tagsprops.config.configured_value,"tagsprops.config.type_of_config",tagsprops.config.type_of_config,"tagsprops.config.configured_value",tagsprops.config.configured_value)

                        if(tagsprops.config.type_of_config==="datewise"){
                            var config_value = tagsprops.config.configured_value;
                            if(typeof config_value =="string"){
                                config_value = generalconfig[tagsprops.config.configured_value];
                            }
                            //console.log("tagcollectionreplica key config_value generalconfig", config_value,"tagsprops",tagsprops);
                            config_value = Number(config_value)
                            var config_value_per_day = config_value / 365;
                            var config_val_tags = [];
                            //console.log("HERE LOGGED difference_days",difference_days,"sdateobject",sdateobject,"edateobject",edateobject)
                            if (difference_days === 365 || difference_days === 366) {
                                var currentdate = sdateobject; 
                                var currentmonth = sdateobject.getMonth(); /* 0 ,1,,,,,,11*/  
                                var currentyear = sdateobject.getFullYear();/* 2023 */
                                var currmon =[]
                                var currdates =[]
                                var noofdays =[]
                                while (currentdate < edateobject) 
                                {
                                    currentdate= new Date(currentyear,currentmonth,1)  //points from Jan 01st 2023 to  Dec 01st 2023
                                    const monthname = currentdate.getTime();
                                    var lastDayOfMonth = new Date(currentyear, currentmonth+1, 0);  //points from Jan 31st 2023 to  Dec 31st 2023 
                                    var daysInMonth = lastDayOfMonth.getDate();
                                    var current_config_value = daysInMonth * config_value_per_day;
                                    config_val_tags.push({ x: monthname, y: Number(current_config_value).toFixed(2) });
                                    currentmonth++
                                    noofdays.push(monthname);
                                    currmon.push(currentmonth)
                                    currdates.push(currentdate)
        
                                    if((currentmonth + 1)>12){
                                        break;
                                    }
                                }
                                tag_collection_configuration.push({"tagname":tagsprops.tagid,"data":config_val_tags})
                                var key=tagsprops.tagid;
                                var value=config_val_tags;
                                // Check if the object is extensible
                                if (!Object.isExtensible(tagcollectionreplica)) {
                                    // If not extensible, create a new object with existing properties
                                    tagcollectionreplica = { ...tagcollectionreplica };
                                }
                                tagcollectionreplica[key]=value;
                            }else if (difference_days >= 30 && difference_days <= 31) {
                                var currentdate = new Date(sdateobject); 
                                while (currentdate <= edateobject) {
                                    const daydate = currentdate.getTime();
                                    const current_config_value = 1 * config_value_per_day;
                                    config_val_tags.push({ x: daydate, y: Number(current_config_value).toFixed(2) });
                                    // Move to the next day
                                    currentdate.setDate(currentdate.getDate() + 1);
                                }
                                
                                tag_collection_configuration.push({"tagname":tagsprops.tagid,"data":config_val_tags})
                                var key=tagsprops.tagid;
                                var value=config_val_tags;
                                // Check if the object is extensible
                                if (!Object.isExtensible(tagcollectionreplica)) {
                                    // If not extensible, create a new object with existing properties
                                    tagcollectionreplica = { ...tagcollectionreplica };
                                }
                                tagcollectionreplica[key]=value;
                                //console.log("tagcollectionreplica key 1 after month key",key,"value",value)
                            }else if (difference_days == 7) {
                                var currentdate = new Date(sdateobject); 
                                while (currentdate <= edateobject) {
                                    const dayName = currentdate.getTime();
                                    const current_config_value = 1 * config_value_per_day;
                                    config_val_tags.push({ x: dayName, y: Number(current_config_value).toFixed(2) });
        
                                    // Move to the next day
                                    currentdate.setDate(currentdate.getDate() + 1);
                                }
                                tag_collection_configuration.push({"tagname":tagsprops.tagid,"data":config_val_tags})
                                var key=tagsprops.tagid;
                                var value=config_val_tags;
                                // Check if the object is extensible
                                if (!Object.isExtensible(tagcollectionreplica)) {
                                    // If not extensible, create a new object with existing properties
                                    tagcollectionreplica = { ...tagcollectionreplica };
                                }
                                tagcollectionreplica[key]=value;
                                //console.log("tagcollectionreplica key 1 after week key",key,"value",value)
                            } else if (difference_days <=3) {
                                var currentdate = new Date(sdateobject); 
                                while (currentdate <= edateobject) {
                                    const hourdate = currentdate.getTime();
                                    const daydate = currentdate.getDate();
                                    const month = currentdate.getMonth() + 1; // JavaScript months are 0-11
                                    const year = currentdate.getFullYear();
                                    
                                    const current_config_value = 1 * config_value_per_day / 24; // Assuming config_value_per_day is for 24 hours
                                    
                                    config_val_tags.push({ x:hourdate + 1, y: Number(current_config_value).toFixed(2) });
                                    
                                    // Move to the next hour
                                    currentdate.setHours(currentdate.getHours() + 1);
                                }
                            
                                tag_collection_configuration.push({ "tagname": tagsprops.tagid, "data": config_val_tags });
                                var key = tagsprops.tagid;
                                var value = config_val_tags;
                            
                                // Check if the object is extensible
                                if (!Object.isExtensible(tagcollectionreplica)) {
                                    // If not extensible, create a new object with existing properties
                                    tagcollectionreplica = { ...tagcollectionreplica };
                                }
                                tagcollectionreplica[key] = value;
                            }else {
                                var currentdate = new Date(sdateobject); 
                                while (currentdate <= edateobject) {
                                    const daydate = currentdate.getTime();
                                    const current_config_value = 1 * config_value_per_day;
                                    config_val_tags.push({ x: daydate, y: Number(current_config_value).toFixed(2) });
                                    // Move to the next day
                                    currentdate.setDate(currentdate.getDate() + 1);
                                }
                                
                                tag_collection_configuration.push({"tagname":tagsprops.tagid,"data":config_val_tags})
                                var key=tagsprops.tagid;
                                var value=config_val_tags;
                                // Check if the object is extensible
                                if (!Object.isExtensible(tagcollectionreplica)) {
                                    // If not extensible, create a new object with existing properties
                                    tagcollectionreplica = { ...tagcollectionreplica };
                                }
                                tagcollectionreplica[key]=value;
                            } 
                            //console.log("tagcollectionreplica key after difference_days",tagcollectionreplica,"difference_days",difference_days,"sdate_edate_selected",sdate_edate_selected)
                    
                            
                        }
                        else if(tagsprops.config.type_of_config==="uniform"){
                            var config_value = tagsprops.config.configured_value;
                            //var config_value_per_day = config_value / 365;
                            var config_val_tags = [];
                        // console.log("DataCollection tagsprops.tagid",tagsprops.tagid,"config_value",config_value,"config_value_per_day",config_value_per_day)
                            if (difference_days === 365 || difference_days === 366) {
                                var currentdate = sdateobject; 
                                var currentmonth = sdateobject.getMonth(); /* 0 ,1,,,,,,11*/  
                                var currentyear = sdateobject.getFullYear();/* 2023 */
                                
                                var currmon =[]
                                var currdates =[]
                                var noofdays =[]
                                while (currentdate < edateobject) 
                                {
                                    currentdate= new Date(currentyear,currentmonth,1)  //points from Jan 01st 2023 to  Dec 01st 2023
                                    const monthname = currentdate.getTime();
                                    var lastDayOfMonth = new Date(currentyear, currentmonth+1, 0);  //points from Jan 31st 2023 to  Dec 31st 2023 
                                    var daysInMonth = lastDayOfMonth.getDate();
                                    config_val_tags.push({ x: monthname, y: Number(config_value).toFixed(2) });
                                    currentmonth++
                                    noofdays.push(monthname);
                                    currmon.push(currentmonth)
                                    currdates.push(currentdate)
        
                                    if((currentmonth + 1)>12){
                                        break;
                                    }
                                }
                                tag_collection_configuration.push({"tagname":tagsprops.tagid,"data":config_val_tags})
                                var key=tagsprops.tagid;
                                var value=config_val_tags;
                                // Check if the object is extensible
                                if (!Object.isExtensible(tagcollectionreplica)) {
                                    // If not extensible, create a new object with existing properties
                                    tagcollectionreplica = { ...tagcollectionreplica };
                                }
                                tagcollectionreplica[key]=value;
                            }else if (difference_days >= 30 && difference_days <= 31) {
                                var currentdate = new Date(sdateobject); 
                                while (currentdate <= edateobject) {
                                    const daydate = currentdate.getTime();
                                    config_val_tags.push({ x: daydate, y: Number(config_value).toFixed(2) });
                                    // Move to the next day
                                    currentdate.setDate(currentdate.getDate() + 1);
                                }
                                
                                tag_collection_configuration.push({"tagname":tagsprops.tagid,"data":config_val_tags})
                                var key=tagsprops.tagid;
                                var value=config_val_tags;
                                // Check if the object is extensible
                                if (!Object.isExtensible(tagcollectionreplica)) {
                                    // If not extensible, create a new object with existing properties
                                    tagcollectionreplica = { ...tagcollectionreplica };
                                }
                                tagcollectionreplica[key]=value;
                            }else if (difference_days == 7) {
                                var currentdate = new Date(sdateobject); 
                                while (currentdate <= edateobject) {
                                    const dayName = currentdate.getTime();
                                    config_val_tags.push({ x: dayName, y: Number(config_value).toFixed(2) });
        
                                    // Move to the next day
                                    currentdate.setDate(currentdate.getDate() + 1);
                                }
                                tag_collection_configuration.push({"tagname":tagsprops.tagid,"data":config_val_tags})
                                var key=tagsprops.tagid;
                                var value=config_val_tags;
                                // Check if the object is extensible
                                if (!Object.isExtensible(tagcollectionreplica)) {
                                    // If not extensible, create a new object with existing properties
                                    tagcollectionreplica = { ...tagcollectionreplica };
                                }
                                tagcollectionreplica[key]=value;
                            }else if (difference_days <= 3) {
                                var currentdate = new Date(sdateobject); 
                                while (currentdate <= edateobject) {
                                    const hourdate = currentdate.getTime();
                                    const daydate = currentdate.getDate();
                                    const month = currentdate.getMonth() + 1; // JavaScript months are 0-11
                                    const year = currentdate.getFullYear();
                                    
                                    const current_config_value = 1 * config_value_per_day / 24; // Assuming config_value_per_day is for 24 hours
                                    
                                    config_val_tags.push({ x: hourdate + 1, y: Number(config_value).toFixed(2) });
                                    
                                    // Move to the next hour
                                    currentdate.setHours(currentdate.getHours() + 1);
                                }
                            
                            
                                tag_collection_configuration.push({ "tagname": tagsprops.tagid, "data": config_val_tags });
                                var key = tagsprops.tagid;
                                var value = config_val_tags;
                            
                            
                                // Check if the object is extensible
                                if (!Object.isExtensible(tagcollectionreplica)) {
                                    // If not extensible, create a new object with existing properties
                                    tagcollectionreplica = { ...tagcollectionreplica };
                                }
                            
                            
                                tagcollectionreplica[key] = value;
                            }else{
                                var currentdate = new Date(sdateobject); 
                                while (currentdate <= edateobject) {
                                    const daydate = currentdate.getTime();
                                    //const current_config_value = 1 * config_value_per_day;
                                    config_val_tags.push({ x: daydate, y: Number(config_value).toFixed(2) });
                                    // Move to the next day
                                    currentdate.setDate(currentdate.getDate() + 1);
                                }
                                
                                tag_collection_configuration.push({"tagname":tagsprops.tagid,"data":config_val_tags})
                                var key=tagsprops.tagid;
                                var value=config_val_tags;
                                // Check if the object is extensible
                                if (!Object.isExtensible(tagcollectionreplica)) {
                                    // If not extensible, create a new object with existing properties
                                    tagcollectionreplica = { ...tagcollectionreplica };
                                }
                                tagcollectionreplica[key]=value;
                            }
                        }else if(tagsprops.config.type_of_config==="constant"){
                            var config_value = tagsprops.config.configured_value;
                            tag_collection_configuration.push({"tagname":tagsprops.tagid,"data":config_value})
                                var key=tagsprops.tagid;
                                var value=config_value;
                                // Check if the object is extensible
                                if (!Object.isExtensible(tagcollectionreplica)) {
                                    // If not extensible, create a new object with existing properties
                                    tagcollectionreplica = { ...tagcollectionreplica };
                                }
                                tagcollectionreplica[key]=value;
                        }
                        
                    }else{

                        if(linkages != "" && addLinkageKey==false){
                            tag_collection_query_db.push(linkageobject, tagsprops);
                            addLinkageKey = true;
                        }
                        else{
                            tag_collection_query_db.push(tagsprops);
                        }
                        
                    }
                        
                })
            }
    }):tagcollectionreplica={}

    for (const property in tagcollectionreplica) {
        if (Array.isArray(tagcollectionreplica[property]) && tagcollectionreplica[property].length > 0) {
            var currentobjects = tagcollectionreplica[property].map(obj => ({ ...obj }));
            if(property == 'vtag_internal_disputes'){
                for(var i=0;i<currentobjects.length;i++){
                    if((i==5) || (i==8)){
                        currentobjects[i].y =10;
                    }else if((i==10) || (i==12)){
                        currentobjects[i].y =2;
                    }else{
                        currentobjects[i].y =0;
                    }
                }
            }

            if(property == 'vtag_discrimnitation'){
                for(var i=0;i<currentobjects.length;i++){
                    if((i==5) || (i==8)){
                        currentobjects[i].y =10;
                    }else if((i==10) || (i==12)){
                        currentobjects[i].y =2;
                    }else{
                        currentobjects[i].y =0;
                    }
                }
            }

            if(property == 'vtag_bribery'){
                for(var i=0;i<currentobjects.length;i++){
                    if((i==5) || (i==8)){
                        currentobjects[i].y =10;
                    }else if((i==10) || (i==12)){
                        currentobjects[i].y =2;
                    }else{
                        currentobjects[i].y =0;
                    }
                }
            }

            tagcollectionreplica[property] = currentobjects;
        }
    }
          
    // console.log("tag_collection_query_db in DataCollectionJS",tag_collection_query_db,"flag",flag)
    tagcollection = tagcollectionreplica;
    return tagcollectionreplica;
}


export { tagcollection, tagnames, tag_collection_query_db, flag, tagcollectionreplica };